// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){
	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});
		$('.header__burger').click(function() {
		    $('.header__burger').toggleClass('active');
		    $('#primary-nav').slideToggle();
			var text = $('.header__burger-label').text();
			$('.header__burger-label').text(text == "Menu" ? "Close" : "Menu");
		}); 
	});
	
	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	if (document.getElementById('form_id-1824-yes-signup-formemail-signup')){
		console.log('true');
		document.getElementById('form_id-1824-yes-signup-formemail-signup').classList.add('required');
	}

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

}